import Swiper, { Navigation, Pagination, Scrollbar, Autoplay } from "swiper";
window.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".hero-swiper").forEach(element => {
    if (element.dataset.disableSlide === "1") return; // disable slider if there are less than 2 elements

    // noinspection JSCheckFunctionSignatures
    const swiper = new Swiper(element, {
      modules: [Navigation, Pagination, Scrollbar, Autoplay],
      loop: true,
      // spaceBetween: 30,
      centeredSlides: true,
      autoplay: {
        delay: 7500,
        disableOnInteraction: false
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      }
    });
    const toggleSlideButton = element.querySelector(".toggle-auto-slide");
    toggleSlideButton.addEventListener("click", () => {
      if (swiper.autoplay.paused) {
        toggleSlideButton.classList.remove("pause");
        swiper.autoplay.resume();
      } else {
        toggleSlideButton.classList.add("pause");
        swiper.autoplay.pause();
      }
    });
  });
});